import parsePhoneNumberFromString, {
  formatNumber,
  isPossiblePhoneNumber,
  ParsedNumber,
  parseNumber,
} from "libphonenumber-js";

export const US_PHONE_MASK = [
  "(",
  /[1-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

// Strict: a real, assigned US number — mirrors the interest-import validator's original semantics.
export const isValidUSPhoneNumber = (value: string): boolean => {
  try {
    const parsed = parsePhoneNumberFromString(value, "US");
    return parsed ? parsed.isValid() : false;
  } catch {
    return false;
  }
};

// Lenient: correct length/pattern only, so unassigned area codes (e.g. 555) still pass.
export const isPossibleUSPhoneNumber = (value: string): boolean => {
  try {
    return isPossiblePhoneNumber(value, "US");
  } catch {
    return false;
  }
};

export const formatPhone = (num: string | null): string => {
  if (!(typeof num === "string")) return "";

  try {
    const parsed = parseNumber(num, "US");
    if (Object.keys(parsed).length === 0) return num;
    const formatted = formatNumber(parsed as ParsedNumber, "NATIONAL");
    return formatted;
  } catch (e) {
    console.error("Error formatting phone number", e, num);
    return num;
  }
};
